/*                                                                           */
import.meta.glob("./common/performance.ts", { eager: true });
import.meta.glob("./common/ios-font-size.ts", { eager: true });

import { isOnexVariant } from "@otto-ec/global-resources/onex";

/*                                             */
import "@otto-ec/design-tokens/theme/theme.scss";

import.meta.glob("./common/customElement/extend.ts", { eager: true });
import.meta.glob("./**/*.global.scss", { eager: true });

/*                                                                    */
import "./scss/icon/icon.g.scss";

/*                                                                        */
import.meta.glob("./components/**/*.sync.svelte", { eager: true });

/*          */
if (isOnexVariant("E3xxx", "Testgroup")) {
  document.documentElement.dataset.onex = "yeah";
}
